import "./style.scss";
import { gsap } from "gsap";
import { Flip } from "gsap/Flip";
import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import useStore from "../../hooks/useStore";

gsap.registerPlugin(Flip);

export default function XrayToggle() {
  const xray = useStore((state) => state.xray);
  const setXray = useStore((state) => state.setXray);
  const toggleRef = useRef(null);
  const state = Flip.getState(".xray-indicator");
  useGSAP(() => {
    Flip.from(state, {
      duration: 0.3,
      ease: "power2.inOut",
      absolute: true,
    });
  }, [xray]);

  return (
    <div className="xray-toggle" data-state={xray ? "xray" : "ui"}>
      <div
        className="xray-indicator"
        onClick={() => setXray(!xray)}
        ref={toggleRef}
      ></div>
    </div>
  );
}
